module.exports = __webpack_public_path__ + "img/web2x_changjing.5d56ff68.png";